import { render, staticRenderFns } from "./SvgStore.vue?vue&type=template&id=8a26d63c&scoped=true&"
import script from "./SvgStore.vue?vue&type=script&lang=js&"
export * from "./SvgStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a26d63c",
  null
  
)

export default component.exports